import { gql, useQuery } from '@apollo/client';
import './home.scss';
import { LayoutSectionComponentType } from 'types';
import Footer from 'components/footer/Footer';
import Nav from 'components/nav/Nav';
import LayoutBlocks from 'components/layoutBlocks/LayoutBlocks';
import PageHeaderWProps from 'components/pageHeader/PageHeader';
import AccordionSection from 'components/accordion/AccordionSection';
import { Head } from '../../components/Head';
import Loader from '../../components/loader/Loader';

const GET_HOME = gql`
  query GET_HOME {
    contentPage(where: { contentPageUrl: "home" }) {
      id
      hideNav
      hideFooter
      hideHeader
      contentPageUrl
      title
      subtitle
      heroImage {
        id
        url
      }
      pageWidthStyle
      contentPageJson
      layoutSection {
        layoutSectionContent {
          heroMediaSlider {
            mediaType
            sliderCssWrapper
            sliderMediaBackground {
              url
            }
            textContent {
              contentImage {
                url
              }
              header {
                html
              }
              subHeader {
                html
              }
              content {
                html
              }
              contentAlign
              link
              imageStyle
              headerFont
              subHeaderFont
              contentFont
              textContentWidth
            }
            callToAction {
              ctaLink
              ctaLabel
              ctaClass
              ctaPrimary
            }
          }
          htmlIdWrapper
          cssClassWrapper
          hideSection
          textContent {
            textContentWidth
            contentImage {
              url
            }
            header {
              html
            }
            subHeader {
              html
            }
            content {
              html
            }
            contentAlign
            link
            imageStyle
          }
          callToAction {
            ctaLink
            ctaLabel
            ctaClass
            ctaPrimary
          }
          backgroundImage {
            url
          }
          parallaxImage {
            url
          }
          gridBox {
            boxTitle
            boxLink
            boxDescription {
              html
            }
            boxImage {
              url
            }
          }
          logoTableSection {
            logoTableTitle
            logoTableQuery
          }
          contactForm {
            contactFormTitle
            contactFormCssWrapper
            jotformUrl
            hubspotFormId
            hubspotPortalId
            netlifyContactForm
            contactFormDescription {
              html
            }
          }
          videoBox {
            videoTitle
            youtubeVideoId
            vimeoVideoId
            youtubePlaylistId
          }
          testimonialSelection {
            testimonialTitle
            testimonialQuery
          }
          galleryLayout
          sliderGallery(first: 500) {
            url
          }
          eventSection {
            eventDisplayType
            eventSectionTitle
          }
          standOutText
          displayBlogSection
          blogSectionTitle
          memberSectionTitle
          memberSelect
          memberCardLayout
          displayWhatsAppFloat
          displayMusicSection
          displayAllMusic
          mailchimpLink
          mailchimpTitle
          mailchimpSubtitle
          iFrameTitle
          iFrameCode
          displayInstagramSectionUsername
        }
      }
      accordion {
        header {
          html
        }
        accordionContent {
          contentHeader {
            html
          }
          contentDescription {
            html
          }
          videoBox {
            videoTitle
            youtubeVideoId
            vimeoVideoId
            youtubePlaylistId
          }
          contentImage {
            url
          }
        }
      }
    }
  }
`;

function HomePage() {
  const { loading, data } = useQuery(GET_HOME);
  if (!data) return <div />;
  const { contentPage } = data;
  if (loading) return <Loader height="60vh" />;

  const {
    title,
    subtitle,
    heroImage,
    contentPageJson,
    layoutSection,
    pageWidthStyle,
    accordion,
    hideNav,
    hideFooter,
    hideHeader,
  } = contentPage;

  console.log('contentPageJson', contentPageJson);

  return (
    <>
      <Head metaTitle={title} />
      <Nav hideNav={hideNav} />
      <PageHeaderWProps
        pageHeaderImageProp={heroImage?.url}
        pageHeaderTitleProp={title}
        pageHeaderSubtitleProp={subtitle}
        pageHeaderWrapperCssClassProp=""
        pageWidthStyle={pageWidthStyle}
        hideHeader={hideHeader}
      />
      {!!layoutSection && (
        <div className="w-full px-0 mx-0">
          {layoutSection.map(
            (layoutSectionBlocks: LayoutSectionComponentType) => (
              <LayoutBlocks
                layoutSectionBlocksData={layoutSectionBlocks}
                key={Math.random()}
              />
            ),
          )}
        </div>
      )}
      <AccordionSection accordionData={accordion} />
      <Footer hideFooter={hideFooter} />
    </>
  );
}

export default HomePage;
